<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <linearGradient :id="id" x2="0" y2="1">
      <stop offset="0%" stop-color="rgba(165, 134, 255, 1)" />
      <stop offset="100%" stop-color="rgba(18, 110, 130, 1)" />
    </linearGradient>
    <path d="M6 22v-16h16v7.543c0 4.107-6 2.457-6 2.457s1.518 6-2.638 6h-7.362zm18-7.614v-10.386h-20v20h10.189c3.163 0 9.811-7.223 9.811-9.614zm-10 1.614h-5v-1h5v1zm5-4h-10v1h10v-1zm0-3h-10v1h10v-1zm2-7h-19v19h-2v-21h21v2z" :fill="url"/>
  </svg>
</template>

<script>
import icon from '@/mixins/icon'

export default {
  name: 'List',
  mixins: [icon]
}
</script>